import { FC } from "react";
import DynamicSvgLoader from "../../../dynamicSvgLoader";
import WeatherAlertIcon from "../../weather/weatherAlert";
import weatherStatisticsArray from "../../weather/weatherStatisticArray";
import Carousel from "../../../carousel/carousel";
import { useForecastContext } from "../../../../context/forecastContext";
import "./dailyWeatherForecast.css";
import SkeletonLoader from "../../../SkeletonLoader";
import ErrorMessage from "../../../errorMessage/errorMessage";
import { useWeatherQuery } from "../../../../services/weatherService";
import { findWeatherForecatForDate } from "../../../../utilities/weatherHelpers";
import dayjs from "dayjs";

const DailyWeatherForecast: FC = () => {
  const { forecastState } = useForecastContext();
  const {
    data: weather,
    isLoading,
    isError,
  } = useWeatherQuery({
    location: forecastState.selectedSite?.postCode!,
    searchPeriod: forecastState.searchPeriod,
  });

  if (isLoading) {
    return <SkeletonLoader />;
  }
  if (isError) {
    return <ErrorMessage dataType="Weather Forecast" fontSize="13px" />;
  }

  const weatherForecast = findWeatherForecatForDate(
    dayjs(forecastState.selectedDate),
    weather ?? []
  );
  return weatherForecast ? (
    <div className="daily-forecast-widget">
      <div className="daily-forecast-main-content">
        <div className="daily-forecast-icon">
          <DynamicSvgLoader iconName={weatherForecast.icon} />
        </div>
        <div className="daily-forecast-temperature">
          {weatherForecast.temperature}
        </div>
        <div className="daily-forecast-conditions">
          <span>{weatherForecast.conditions}</span>
          <span>{`Feels Like ${weatherForecast.feelsLike}`}</span>
        </div>
        {weatherForecast.alerts?.length > 0 && (
          <WeatherAlertIcon alert={weatherForecast.alerts} size="extraLarge" />
        )}
      </div>
      <div className="daily-forecast-description">
        {weatherForecast.description}
      </div>
      <div className="daily-forecast-footer">
        <Carousel
          components={weatherStatisticsArray(weatherForecast)}
          intervalToChange={5000}
          visibleCount={5}
          gap="5px"
        />
      </div>
    </div>
  ) : (
    // to-do - create a proper no data message - reuse across components
    <></>
  );
};

export default DailyWeatherForecast;
